/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const CORE_PROCEDURE_DATA_FRAGMENT = gql`
  fragment procedureData on Procedure {
    id
    departmentId
    name
    owner
    language
    title
    stage
    text
    departmentVersion
    version
  }
`;

export const PROCEDURE_SUMMARY_FRAGMENT = gql`
  fragment procedureSummary on Procedure {
    id
    name
    version
    departmentVersion
    stage
  }
`;
